
export const ADD_NOTIFICATION_REQUEST = "[NOTIFICATIONS] ADD_NOTIFICATION_REQUEST";
export const ADD_NOTIFICATION = "[NOTIFICATIONS] ADD_NOTIFICATION";
export const START_NOTIFICATION_TRANSITION = "[NOTIFICATIONS] START_NOTIFICATION_TRANSITION";
export const REMOVE_NOTIFICATION_REQUEST = "[NOTIFICATIONS] REMOVE_NOTIFICATION_REQUEST";
export const REMOVE_NOTIFICATION = "[NOTIFICATIONS] REMOVE_NOTIFICATION";
export const HOVER = "[NOTIFICATIONS] HOVER";
export const UNHOVER = "[NOTIFICATIONS] UNHOVER";


// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-action-types.js